import { PulseStorage, StorageChangeKeyMatch, StorageChangeOrigin } from '@pulse/common';
import { QueryParamsService } from './query-params.service';

export class UserRoleService extends QueryParamsService {
    constructor(
        protected override readonly pulseStorage: PulseStorage,
        public override readonly STORAGE_KEY = 'ur',
    ) {
        super(pulseStorage, STORAGE_KEY, StorageChangeKeyMatch.Full, StorageChangeOrigin.All);
    }
}
